import React from "react";
import PropTypes from "prop-types";
import { CK_APP_VERSION } from "../../utils/helper";
export default function AppVersion(props) {
  const { textColor, textSize } = props;

  return (
    <div
      style={{
        marginTop: 20,
        display: "flex",
        justifyContent: "center",
        color: textColor,
        fontSize: textSize,
      }}
    >
      CK App - {CK_APP_VERSION}
    </div>
  );
}

AppVersion.propTypes = {
  textColor: PropTypes.any,
  textSize: PropTypes.any,
};

AppVersion.defaultProps = {
  textColor: "grey",
  textSize: 12,
};
